
import axios from 'axios'

import * as types from '../mutation-types'


export const state = {

    // modelos de (Topo e Rodapé) dentre outros que vem do usuário
    modelo_doc: {
        model_doc_topo: '',
        model_doc_rodape: '',
        contrato: '',
        comprovante: '',
        doc_edit: '' //parâmentro {doc_edit} que define qual doc
        // será editado ex: 'model_doc_topo', 'model_doc_rodape', etc...
    }

}

//
// export const getters = {
//
// }

//
export const actions = {

  //ao carregar estrutura de impressão {topo e rodapé}
  async getModeloDoc({ dispatch, commit}){
      try {
        const { data } = await axios.get('/api/documentos-json') //{topo e rodapé}
        commit(types.SET_MODELO_DOC,{ modelo_doc: data})
      } catch (e) {
        dispatch('alert/erroAoCarregar', 'a Página de impressão' ,{ root: true })
      }
  },

  // Cabeçalho, topo, contrato e comprovante
  async updateModelDocUser({ dispatch, commit }, { modelo_doc }){

    try {
      const { data } = await axios.post('/api/documentos-json', modelo_doc)
      if (data.id) {
          dispatch('alert/editadoComSucesso', 'Documento' ,{ root: true })
          commit(types.SET_MODELO_DOC,{ modelo_doc: data})
      }else {
          dispatch('alert/erroAoSalvar', null ,{ root: true })
      }
    } catch (e) {
        dispatch('alert/erroAoSalvar', null ,{ root: true })
    }

  }


}

//
export const mutations = {

  [types.SET_MODELO_DOC](state, { modelo_doc }){
      state.modelo_doc = modelo_doc
  }

}





//



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/documento.js